import { render, staticRenderFns } from "./Rescue.vue?vue&type=template&id=5913f219&scoped=true&"
import script from "./Rescue.vue?vue&type=script&lang=js&"
export * from "./Rescue.vue?vue&type=script&lang=js&"
import style0 from "./Rescue.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Rescue.vue?vue&type=style&index=1&id=5913f219&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5913f219",
  null
  
)

export default component.exports